import type { RouteRecordNameGeneric } from '#vue-router';

// The two zones where a traveller holds a live search; what each is worth belongs to its reader.
export type SessionArea = 'results' | 'funnel';

export const currentSessionArea = (routeName: RouteRecordNameGeneric): SessionArea | undefined => {
  if (currentFunnelPage(routeName)) {
    return 'funnel';
  }
  return isRoute(routeName, 'results') ? 'results' : undefined;
};
